import React from 'react';
import styles from '../../css/Part4.module.css';

const UserCard = ({ name, points, description, backgroundImage }) => {
  return (
    <div className={styles.userCard}>
      <div className={styles.userCardContent}>
        <img src={backgroundImage} alt="" className={styles.userCardBackground} />
        <div className={styles.userName}>{name}</div>
        <div className={styles.userPoints}>{points}fp</div>
        <div className={styles.userDescription}>{description}</div>
      </div>
    </div>
  );
};

const LoyaltyProgram = () => {
  const userCards = [
    {
      name: 'KHAIRILHUSNI',
      points: '709.95',
      description: '“The bigger your community, the more FonePoints (FP) you can earn when your community spends in FoneApp.”',
      backgroundImage: 'images/background/Rectangle 24.png'
    },
    {
      name: 'henryseow',
      points: '1243.52',
      description: '“Share your referral link with friends and family to start earning FonePoint, just like i do!”',
      backgroundImage: 'images/background/Rectangle 24.png'
    },
    {
      name: 'CHEKHAU88',
      points: '1233.69',
      description: '“A memorable M2O experience? Referring a friend, growing our community, and seeing rewards multiply.”',
      backgroundImage: 'images/background/Rectangle 24.png'
    }
  ];

  return (
    <section className={styles.loyaltyProgram}>
      <div className={styles.background}>
        <div className={styles.container}>
          <h1 className={styles.mainHeading}>Wish to be one<br/>of them?</h1>
          <p className={styles.description}>
            FoneApp uses the concept of recycling community's spending to reward its users. Every FoneApp user will be given a community structure of 21,844.
            <br /><br />
            Whenever your community spends, you will earn 0.1%, accumulated monthly. Ultimately, you're earning points that can be converted monetarily within FoneApp.
          </p>
          <div className={styles.imageGrid}>
            <div className={styles.gridRow}>
              <div className={styles.gridColumn}>
                <img src="images/Testimonial/Mask group.png" alt="" className={styles.gridImage} />
              </div>
              <div className={styles.gridColumn}>
                <img src="images/Testimonial/Mask group (3).png" alt="" className={styles.gridImage1} />
              </div>
              <div className={styles.gridColumn}>
                <img src="images/Testimonial/Mask group (1).png" alt="" className={styles.gridImage2} />
              </div>
            </div>
          </div>
          <div className={styles.userCardContainer}>
            <div className={styles.userCardRow}>
              {userCards.map((user, index) => (
                <div key={index} className={styles.gridColumn}>
                  <UserCard {...user} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoyaltyProgram;